export const environment = {
  production: false,
   api: "https://api-accounting.vms-systems.com/api",
};
